import React, { useEffect } from "react";
import Navigation from "./Navigation";
import Footer from "./Footer";

function Faqs() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <div className="sub-banner-section-outer">
        <Navigation />
        <section className="sub-banner-section">
          <div className="container">
            <div className="row">
              <div className="col-12 text-center">
                <div className="sub-banner-text">
                  <h1 className="mb-lg-4 mb-3 text-white">FAQ</h1>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>

      <h2 className="text-center my-5">Sign Up Process</h2>

      <div class="accordian-section ">
        <div class="container">
          <div class="row">
            <div class="col-lg-12 col-md-6 col-sm-12">
              <div class="about-service-section-text accordian-section-inner-text position-relative">
                <div class="accordian-inner">
                  <div id="accordionZero">
                    <div class="accordion-card">
                      <div class="card-header" id="headingZero">
                        <h4 class="mb-0">
                          <button
                            class="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapseZero"
                            aria-expanded="false"
                            aria-controls="collapseZero"
                          >
                            How long does it take to onboard my store?
                          </button>
                        </h4>
                      </div>
                      <div
                        id="collapseZero"
                        class="collapse"
                        aria-labelledby="headingZero"
                      >
                        <div class="card-body">
                          <p class="text-size-16 ">
                            The Onboarding process is very simple and can be
                            completed within a few hours from start to finish,
                            with the majority of the heavy lifting completed by
                            our team.
                          </p>
                          <p class="text-size-16 ">
                            Once you sign up for our call center program, our
                            operation team adds your stores to our call center
                            platform. They will also reach out to the week prior
                            to onboarding your store to walk you through the
                            onboarding process and provide you with DID transfer
                            numbers.
                          </p>
                          <p class="text-size-16 ">
                            In addition, we only add stores on Mondays and
                            Tuesdays as they are the two slowest days of the
                            week and this allows us to work with new stores to
                            ensure that everything is working perfect before
                            heading into the busy part of the week.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <h2 className="text-center my-5">General Questions</h2>
      <div class="accordian-section">
        <div class="container">
          <div class="row">
            <div class="col-lg-6 col-md-6 col-sm-12">
              <div class="about-service-section-text accordian-section-inner-text position-relative">
                <div class="accordian-inner">
                  <div id="accordion1">
                    <div class="accordion-card">
                      <div class="card-header" id="headingFour">
                        <h4 class="mb-0">
                          <button
                            class="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapseFour"
                            aria-expanded="false"
                            aria-controls="collapseFour"
                          >
                            Can I use my Own Phone System?
                          </button>
                        </h4>
                      </div>
                      <div
                        id="collapseFour"
                        class="collapse"
                        aria-labelledby="headingFour"
                      >
                        <div class="card-body">
                          <p class="text-size-16 mb-0 p-0">
                            Yes, you can continue to use your own phone system
                            if you choose. However, we do have an extremely
                            cost-effective solution which is fully integrated
                            with our program and works the best with our
                            program. Cost is typically $125-$150 per month for
                            10 phone lines and cellular back up for your phone
                            lines, POS system and Credit Card Processor. If you
                            are in contract with a Phone provider and like to
                            explore our system, we can discuss ways to end the
                            contract
                          </p>
                        </div>
                      </div>
                    </div>
                    <div class="accordion-card">
                      <div class="card-header" id="headingFive">
                        <h4 class="mb-0">
                          <button
                            class="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapseFive"
                            aria-expanded="false"
                            aria-controls="collapseFive"
                          >
                            What is a DID?
                          </button>
                        </h4>
                      </div>
                      <div
                        id="collapseFive"
                        class="collapse"
                        aria-labelledby="headingFive"
                      >
                        <div class="card-body">
                          <p class="text-size-16 ">
                            Directed Inward Numbers (DID’s) are virtual numbers
                            that allow you to route calls to our call centers.
                          </p>
                          <p class="text-size-16 mb-0 p-0">Example:</p>
                          <ul>
                            <li>
                              Customer calls your store’s main phone number to
                              place an order
                            </li>
                            <li>
                              The call is transferred to the calls Center’s DID
                              by your phone provider
                            </li>
                            <li>The customer is directed to our IVR</li>
                            <li>
                              If they are calling about an order, when they
                              press the appropriate number, the call will be
                              transferred to our call center
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                    <div class="accordion-card">
                      <div class="card-header" id="headingSix">
                        <h4 class="mb-0">
                          <button
                            class="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapseSix"
                            aria-expanded="false"
                            aria-controls="collapseSix"
                          >
                            Do you follow CCPA Guidelines?
                          </button>
                        </h4>
                      </div>
                      <div
                        id="collapseSix"
                        class="collapse"
                        aria-labelledby="headingFive"
                      >
                        <div class="card-body">
                          <p class="text-size-16 ">
                            Yes RRS is Compliant with CCPA.
                          </p>
                          <p class="text-size-16 ">
                            The California Consumer Privacy Act is a statewide
                            data privacy law that regulates how businesses all
                            over the world are allowed to handle the personal
                            information of California residents.
                          </p>
                          <p class="text-size-16 ">
                            Who exactly is covered by CCPA? CCPA essentially
                            applies to any entity doing business in California
                            that collects, shares, or sells California
                            consumers’ personal data, and:
                          </p>

                          <ul>
                            <li>
                              Has annual gross revenues in excess of $25
                              million; or
                            </li>
                            <li>
                              Possesses the personal information of 50,000 or
                              more consumers, households, or devices; or
                            </li>
                            <li>
                              Earns more than half of its annual revenue from
                              selling consumers’ personal information.
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-6 col-md-6 col-sm-12">
              <div class="about-service-section-text position-relative">
                <div class="accordian-inner">
                  <div id="accordion2">
                    <div class="accordion-card">
                      <div class="card-header" id="headingSeven">
                        <h4 class="mb-0">
                          <button
                            class="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapseSeven"
                            aria-expanded="false"
                            aria-controls="collapseSeven"
                          >
                            What is an IVR?
                          </button>
                        </h4>
                      </div>
                      <div
                        id="collapseSeven"
                        class="collapse"
                        aria-labelledby="headingSeven"
                      >
                        <div class="card-body">
                          <p class="text-size-16 ">
                            An Interactive Voice Response (IVR) is an automated
                            telephony system that interacts with callers,
                            gathers information and routes the call to the
                            appropriate
                          </p>
                          <p class="text-size-16 mb-0 p-0">Example:</p>
                          <ul>
                            <li>Thank you for calling ABC Pizza. </li>
                            <li>
                              If you are calling about a previously placed
                              order, please press 2{" "}
                            </li>
                            <li>
                              If you are calling about a new order, please press
                              3{" "}
                            </li>
                            <li>
                              If you would like the store hours, please press 4{" "}
                            </li>
                            <li>
                              And if you would like to speak with a manger
                              please press 5{" "}
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                    <div class="accordion-card">
                      <div class="card-header" id="headingEight">
                        <h4 class="mb-0">
                          <button
                            class="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapseEight"
                            aria-expanded="false"
                            aria-controls="collapseEight"
                          >
                            What is PCI Compliance?
                          </button>
                        </h4>
                      </div>
                      <div
                        id="collapseEight"
                        class="collapse"
                        aria-labelledby="headingEight"
                      >
                        <div class="card-body">
                          <p class="text-size-16 ">
                            PCI DSS (Payment Card Industry Data Security
                            Standard) was created in 2004. PCI DSS (or PCI for
                            short) developed industry standards for providers
                            and merchants to make sure that cardholder data was
                            being protected when stored and transmitted.
                          </p>
                          <p class="text-size-16 ">
                            RRS is a PCI Certified Call Center. Learn more about
                            PCI compliance at this website:
                            https://www.pcisecuritystandards.org/
                          </p>
                          <p class="text-size-16 ">
                            All Call Agents must use their key card to enter the
                            building and pass through security. Once in the
                            building they must go to their lockers and lock
                            everything up including their cell phones.
                          </p>
                          <p class="text-size-16 ">
                            Prior to keying themselves onto the call center
                            floor, they must go through security again. There
                            are no pens, pencils, writing utensils of any kind.
                            There is no Paper (including on a water bottle),
                            cell phones cameras or recording devices. Call
                            agents are unable to access the internet or any
                            email through our computer system.
                          </p>
                          <p class="text-size-16 ">
                            Besides many managers, team leads and trainers
                            walking around the room, we also have a security
                            guard that walks the floor along with a security
                            guard that monitors the CCTV cameras that cover the
                            entire floor.
                          </p>
                          <p class="text-size-16 ">
                            Our call centers are randomly audited quarterly to
                            ensure full PCI compliance.
                          </p>
                        </div>
                      </div>
                    </div>
                    <div class="accordion-card">
                      <div class="card-header" id="headingNine">
                        <h4 class="mb-0">
                          <button
                            class="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapseNine"
                            aria-expanded="false"
                            aria-controls="collapseNine"
                          >
                            How do we change Specials or Hours of Operations?
                          </button>
                        </h4>
                      </div>
                      <div
                        id="collapseNine"
                        class="collapse"
                        aria-labelledby="headingNine"
                      >
                        <div class="card-body">
                          <p class="text-size-16 ">
                            You are able to update specials anytime you wish.
                            Stores are able to contact the call center anytime
                            by email or calling the designated Help Desk for
                            your chain. Each Chain is provided their own Help
                            Desk.
                          </p>
                          <p class="text-size-16 ">
                            In the event that you have excess product or running
                            short on an expiration date, feel free to call the
                            help desk and the call center will attempt to upsell
                            that product on every call, until the situation is
                            taken care of.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <h2 className="text-center my-5">Why Should We Use a Call Center?</h2>
      <div class="accordian-section">
        <div class="container">
          <div class="row">
            <div class="col-lg-6 col-md-6 col-sm-12">
              <div class="about-service-section-text accordian-section-inner-text position-relative">
                <div class="accordian-inner">
                  <div id="accordion3">
                    <div class="accordion-card">
                      <div class="card-header" id="heading10">
                        <h4 class="mb-0">
                          <button
                            class="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse10"
                            aria-expanded="false"
                            aria-controls="collapse10"
                          >
                            Improved Customer Service
                          </button>
                        </h4>
                      </div>
                      <div
                        id="collapse10"
                        class="collapse"
                        aria-labelledby="heading10"
                      >
                        <div class="card-body">
                          <p class="text-size-16 ">
                            Our call agents have one job that is to provide
                            outstanding customer service. Every call is taken in
                            a quite office setting and answered by a friendly
                            professional call agent. Each call agent has been
                            trained for over 2 weeks before they take one call.
                            All calls are monitored and recorded for quality and
                            training purposes.
                          </p>
                        </div>
                      </div>
                    </div>
                    <div class="accordion-card">
                      <div class="card-header" id="heading11">
                        <h4 class="mb-0">
                          <button
                            class="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse11"
                            aria-expanded="false"
                            aria-controls="collapse11"
                          >
                            Reduce Labor Costs
                          </button>
                        </h4>
                      </div>
                      <div
                        id="collapse11"
                        class="collapse"
                        aria-labelledby="heading11"
                      >
                        <div class="card-body">
                          <p class="text-size-16">
                            With minimum wage on the rise, RRS’s order taking
                            solution works out to be less than $2 an hour/per
                            call agent that is required to handle a stores call
                            volume.
                          </p>
                          <p class="text-size-16">
                            By Centralizing all calls into one location, RRS is
                            able to provide a cost-effective solution that
                            includes recruiting, hiring, training and managing a
                            dedicate group of call agents assigned specifically
                            to your chain.
                          </p>
                          <p class="text-size-16">
                            Our Clients have noticed that they have been able to
                            reduce the total weekly labor hours depending on a
                            stores call volume from 15-50 hours per week.
                          </p>
                          <p class="text-size-16">
                            In addition, RRS charge a flat fee. There are no set
                            up fees, no additional charges such as FICA, FUTA,
                            SUTA, Worker’s Compensation, Payroll Fees, benefits
                            or paid time off.
                          </p>
                        </div>
                      </div>
                    </div>
                    <div class="accordion-card">
                      <div class="card-header" id="heading12">
                        <h4 class="mb-0">
                          <button
                            class="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse12"
                            aria-expanded="false"
                            aria-controls="collapse12"
                          >
                            Increase Total Transactions
                          </button>
                        </h4>
                      </div>
                      <div
                        id="collapse12"
                        class="collapse"
                        aria-labelledby="heading12"
                      >
                        <div class="card-body">
                          <p class="text-size-16">
                            With minimum wage on the rise, RRS’s order taking
                            solution works out to be less than $2 an hour/per
                            call agent that is required to handle a stores call
                            volume.
                          </p>
                          <p class="text-size-16">
                            By Centralizing all calls into one location, RRS is
                            able to provide a cost-effective solution that
                            includes recruiting, hiring, training and managing a
                            dedicate group of call agents assigned specifically
                            to your chain.
                          </p>
                          <p class="text-size-16">
                            Our Clients have noticed that they have been able to
                            reduce the total weekly labor hours depending on a
                            stores call volume from 15-50 hours per week.
                          </p>
                          <p class="text-size-16">
                            In addition, RRS charge a flat fee. There are no set
                            up fees, no additional charges such as FICA, FUTA,
                            SUTA, Worker’s Compensation, Payroll Fees, benefits
                            or paid time off.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-6 col-md-6 col-sm-12">
              <div class="about-service-section-text position-relative">
                <div class="accordian-inner">
                  <div id="accordion4">
                    <div class="accordion-card">
                      <div class="card-header" id="heading13">
                        <h4 class="mb-0">
                          <button
                            class="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse13"
                            aria-expanded="false"
                            aria-controls="collapse13"
                          >
                            Increase Average Ticket
                          </button>
                        </h4>
                      </div>
                      <div
                        id="collapse13"
                        class="collapse"
                        aria-labelledby="heading13"
                      >
                        <div class="card-body">
                          <p class="text-size-16 ">
                            Less than 30% of the time, employees attempt to
                            upsell. This is typically due to employees being too
                            busy, unsupervised, bad habits etc.…
                          </p>
                          <p class="text-size-16 ">
                            RRS call agents use a call script on every call
                            which has a built in upsell. For that reason, our
                            call agents attempt to upsell 100% of the time.
                          </p>
                          <p class="text-size-16 ">
                            Depending on geographical and customer demographics
                            our average is 22-53% upsells – increasing your
                            average ticket!
                          </p>
                        </div>
                      </div>
                    </div>
                    <div class="accordion-card">
                      <div class="card-header" id="heading14">
                        <h4 class="mb-0">
                          <button
                            class="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse14"
                            aria-expanded="false"
                            aria-controls="collapse14"
                          >
                            Increase Employee Productivity
                          </button>
                        </h4>
                      </div>
                      <div
                        id="collapse14"
                        class="collapse"
                        aria-labelledby="heading14"
                      >
                        <div class="card-body">
                          <p class="text-size-16 ">
                            With the phone not ringing off the hook, your
                            employees are able to focus their attention on
                            making great food fast. In fact, our clients tell us
                            that they have seen their average make time decrease
                            by 40-60 seconds.
                          </p>
                          <p class="text-size-16 ">
                            In addition, because they have more time, they have
                            also noticed much better customer service in the
                            store when customers pick up their orders.
                          </p>
                          <p class="text-size-16 ">
                            Overall owners and managers have seen a big
                            improvement in employee morale and productivity.
                            Having less stressed and happier employees has also
                            helped to decrease employee turnover.
                          </p>
                        </div>
                      </div>
                    </div>
                    <div class="accordion-card">
                      <div class="card-header" id="heading15">
                        <h4 class="mb-0">
                          <button
                            class="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse15"
                            aria-expanded="false"
                            aria-controls="collapse15"
                          >
                            Repeat Business
                          </button>
                        </h4>
                      </div>
                      <div
                        id="collapse15"
                        class="collapse"
                        aria-labelledby="heading15"
                      >
                        <div class="card-body">
                          <p class="text-size-16 ">
                            While every business depends on repeat business, it
                            is extremely important in the restaurant industry.
                          </p>
                          <p class="text-size-16 ">
                            By providing consistent world class service over the
                            phone and in the store as well as quicker make
                            times, this will greatly help with repeat business
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <h2 className="text-center my-5">Customer Service</h2>
      <div class="accordian-section">
        <div class="container">
          <div class="row">
            <div class="col-lg-6 col-md-6 col-sm-12">
              <div class="about-service-section-text accordian-section-inner-text position-relative">
                <div class="accordian-inner">
                  <div id="accordion5">
                    <div class="accordion-card">
                      <div class="card-header" id="heading16">
                        <h4 class="mb-0">
                          <button
                            class="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse16"
                            aria-expanded="false"
                            aria-controls="collapse16"
                          >
                            How are customer complaints handled?
                          </button>
                        </h4>
                      </div>
                      <div
                        id="collapse16"
                        class="collapse"
                        aria-labelledby="heading16"
                      >
                        <div class="card-body">
                          <p class="text-size-16 ">
                            Anytime a customer makes a complaint it is very
                            important to look into that order and determine what
                            happened. RRS urge’s its customer to call the
                            dedicated Help Desk with any customer complaints.
                          </p>
                          <p class="text-size-16 ">
                            Our Quality Assurance team will pull the call,
                            review the call and email their finding along with
                            the call recording to the owner/manager for their
                            review.
                          </p>
                          <p class="text-size-16 ">
                            Over 95% of calls that are pulled due to a customer
                            complaint are actually great phone calls. We find
                            that the customer is either looking for a discount
                            or a free pizza. We do not mind providing these
                            calls because in most cases the owner/manager lets
                            us know what a great job we are doing.
                          </p>
                          <p class="text-size-16 ">
                            That being said, we are human, and we do make
                            mistakes. When we do make a mistake, we make sure to
                            pull that call agent off the phone, play the
                            recording and ask the call agent what they could
                            have done better. If the trainer determines that the
                            call agent requires more training. That call agent
                            will not take any more calls until the issue is
                            resolved.
                          </p>
                          <p class="text-size-16 ">
                            3 Strike rule – Call agents are only allowed three
                            strikes before they removed from a campaign.
                          </p>
                          <p class="text-size-16 ">
                            When a call agent receives a strike, it prevents
                            them from being promoted and obtaining a raise. For
                            this reason, all call agents try to stick to
                            Standard Operating Procedures and protocols so they
                            can rise up the ranks and become an expert call
                            agent
                          </p>
                        </div>
                      </div>
                    </div>
                    <div class="accordion-card">
                      <div class="card-header" id="heading17">
                        <h4 class="mb-0">
                          <button
                            class="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse17"
                            aria-expanded="false"
                            aria-controls="collapse17"
                          >
                            Do I have access to Recordings?
                          </button>
                        </h4>
                      </div>
                      <div
                        id="collapse17"
                        class="collapse"
                        aria-labelledby="heading17"
                      >
                        <div class="card-body">
                          <p class="text-size-16 ">
                            Yes, you are able to request any call recording. We
                            simply need the Phone number of the customer, the
                            day of the call and an approximate time.
                          </p>
                          <p class="text-size-16 ">
                            Owners/managers can request the recording by
                            emailing or calling the Help Desk
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-6 col-md-6 col-sm-12">
              <div class="about-service-section-text position-relative">
                <div class="accordian-inner">
                  <div id="accordion6">
                    <div class="accordion-card">
                      <div class="card-header" id="heading18">
                        <h4 class="mb-0">
                          <button
                            class="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse18"
                            aria-expanded="false"
                            aria-controls="collapse18"
                          >
                            How do I reach the Call Center?
                          </button>
                        </h4>
                      </div>
                      <div
                        id="collapse18"
                        class="collapse"
                        aria-labelledby="heading18"
                      >
                        <div class="card-body">
                          <p class="text-size-16 ">
                            Each chain is provided their very own help Desk. You
                            will be provided contact information for this help
                            desk and can reach the help desk for any reason.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <h2 className="text-center my-5">About Our Call Agents</h2>
      <div class="accordian-section">
        <div class="container">
          <div class="row">
            <div class="col-lg-6 col-md-6 col-sm-12">
              <div class="about-service-section-text accordian-section-inner-text position-relative">
                <div class="accordian-inner">
                  <div id="accordion7">
                    <div class="accordion-card">
                      <div class="card-header" id="heading19">
                        <h4 class="mb-0">
                          <button
                            class="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse19"
                            aria-expanded="false"
                            aria-controls="collapse19"
                          >
                            Where is the Call Center Located?
                          </button>
                        </h4>
                      </div>
                      <div
                        id="collapse19"
                        class="collapse"
                        aria-labelledby="heading19"
                      >
                        <div class="card-body">
                          <p class="text-size-16 ">
                            We have 1 call center in the Philippines and two
                            locations in Pakistan. All of our call agents speak
                            native English with most call agent born and raised
                            in the United States before moving back home to live
                            with their family.
                          </p>
                          <p class="text-size-16 ">
                            Each of our call agents are college educated and
                            have over 3 years of call center experience. Many of
                            our call agents have experience working in Pizza
                            Shops as well.
                          </p>
                          <p class="text-size-16 ">
                            That being said, you have full control of call
                            agents and can request for any call agent to be
                            roved from your account.
                          </p>
                        </div>
                      </div>
                    </div>
                    <div class="accordion-card">
                      <div class="card-header" id="heading20">
                        <h4 class="mb-0">
                          <button
                            class="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse20"
                            aria-expanded="false"
                            aria-controls="collapse20"
                          >
                            How are Call Agents Trained?
                          </button>
                        </h4>
                      </div>
                      <div
                        id="collapse20"
                        class="collapse"
                        aria-labelledby="heading20"
                      >
                        <div class="card-body">
                          <p class="text-size-16 ">
                            We only hire the best agents to fit your campaign.
                            Each Call agent must not only possess the
                            requirements listed below, but also pass our Pizza
                            University.
                          </p>
                          <p class="text-size-16 ">
                            We have a large pool of college educated applicants
                            available. We only hire telemarketers and customer
                            support assistants who are right for this job and
                            have great customer service experience.
                          </p>
                          <p class="text-size-16 ">
                            All of the applicants we screen will have the
                            following basic skills:
                          </p>
                          <p class="text-size-16 ">
                            ✔ 4-year accredited university degree <br />✔ Fluent
                            English language skills, neutral accent <br />✔ At
                            least 1-year call center experience <br />✔ At least
                            1-year outbound sales experience
                          </p>
                          <p class="text-size-16 ">
                            That being said, our call agents go through 14 days
                            of training before taking any phone calls for RRS.
                            Before they start on day one, they are required to
                            memorize your menu and call script.
                          </p>
                          <p class="text-size-16 ">
                            Trainees are quizzed and tested every day and put on
                            the spot for Role Playing at any given time.{" "}
                          </p>
                          <p class="text-size-16 ">
                            They are required to learn our phone systems, our
                            POS system, your menu, your call script, they spend
                            time learning the art of upselling.
                          </p>
                          <p class="text-size-16 ">
                            They spend two days shadowing expert call agents, to
                            see how calls should be handled. They listen to 8
                            hours of calls a day and watch how calls are entered
                            into the system.
                          </p>
                          <p class="text-size-16 ">
                            On the final day of training, they listen to expert
                            call agents take calls, but they enter the orders as
                            the expert agent supervises the process.
                          </p>
                          <p class="text-size-16 ">
                            Only 50% of call agents make it through our Pizza
                            Universit.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-6 col-md-6 col-sm-12">
              <div class="about-service-section-text position-relative">
                <div class="accordian-inner">
                  <div id="accordion8">
                    <div class="accordion-card">
                      <div class="card-header" id="heading21">
                        <h4 class="mb-0">
                          <button
                            class="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse21"
                            aria-expanded="false"
                            aria-controls="collapse21"
                          >
                            How are Call Agents Supervised?
                          </button>
                        </h4>
                      </div>
                      <div
                        id="collapse21"
                        class="collapse"
                        aria-labelledby="heading21"
                      >
                        <div class="card-body">
                          <p class="text-size-16 ">
                            Our call agents are heavily managed and well
                            supervised.
                          </p>
                          <p class="text-size-16 ">
                            <u>
                              <b>Team Leads</b>
                            </u>{" "}
                            – every 15 call agents are assigned a team lead. The
                            team lead sits with their team and is there to help
                            and manage those 15 call agents.
                          </p>
                          <p class="text-size-16 ">
                            <u>
                              <b>Floor Supervisors</b>
                            </u>{" "}
                            - every 5 team leads report to one Floor Supervisor.
                            He manages the overall performance of teams
                            reporting to him, sets their work schedules and
                            coordinates with Training, WFM & QA to run
                            operations.
                          </p>
                          <p class="text-size-16 ">
                            <u>
                              <b>Quality Assurance Team</b>
                            </u>{" "}
                            - the Quality assurance team sits and operates away
                            from the Call Agents & Teams but listens to live
                            calls and recorded calls to make sure all call
                            agents are adhering to all Standard Operating
                            Procedures and protocols, including sticking to the
                            script, upselling on every call, etc. Processes like
                            Calibration, Call Evaluation Accuracy and QA of QA
                            are implemented to ensure unbiased, just & accurate
                            QA evaluation.
                          </p>
                          <p class="text-size-16 ">
                            <u>
                              <b>Trainers </b>
                            </u>{" "}
                            - We have two sets of trainers. We have 3 trainers
                            assigned to working with new call agents, and they
                            we have one trainer assigned to every floor
                            supervisor and work with experience call agents. The
                            trainers that work on the call center floor are
                            constantly sitting with and listening to call agents
                            calls, providing constructive criticism and
                            providing helpful hints. In addition, the trainers
                            conduct a 20-minute session before every shift to go
                            over new SOP’s, point out any issues that keep
                            happening, play phone calls that QA flagged as
                            issues and address those calls. Also play perfect
                            calls and give praise when it is deserved.
                          </p>
                          <p class="text-size-16 ">
                            <u>
                              <b>Campaign Manager</b>
                            </u>{" "}
                            – The campaign supervisor over sees the entire
                            chains management team and call agents. All the Team
                            lead, floor supervisors, Quality Assurance Team and
                            Training team reports to the campaign Manager.
                          </p>
                        </div>
                      </div>
                    </div>
                    <div class="accordion-card">
                      <div class="card-header" id="heading22">
                        <h4 class="mb-0">
                          <button
                            class="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse22"
                            aria-expanded="false"
                            aria-controls="collapse22"
                          >
                            Call Agent Motivation
                          </button>
                        </h4>
                      </div>
                      <div
                        id="collapse22"
                        class="collapse"
                        aria-labelledby="heading22"
                      >
                        <div class="card-body">
                          <p class="text-size-16 ">
                            All call agents are heavily motivated to succeed. In
                            addition to daily competitions and bonuses, call
                            agents are also urged to move up the chain. 90% of
                            positions are fill from within and through
                            promotions.
                          </p>
                          <p class="text-size-16 ">
                            <u>
                              <b>Trainee</b>
                            </u>{" "}
                            - Once a call agent graduates from training they are
                            still considered a trainee for 30 days. After 30
                            days a call agent is eligible for a promotion if
                            they have not had any strikes and two managers
                            recommend them for a promotion.
                          </p>
                          <p class="text-size-16 ">
                            <u>
                              <b>Level 3 Agent </b>
                            </u>{" "}
                            -– If promoted to a level 3 call agent the call
                            agent receives recognition along with a raise. After
                            30 days these call agents are eligible for another
                            promotion as long as they have not received a strike
                            and have been recommended by 2 managers.
                          </p>
                          <p class="text-size-16 ">
                            <u>
                              <b>Level 2 Agent</b>
                            </u>{" "}
                            - If promoted to this level, the call agent receives
                            recognition along with a raise. After 90 days, these
                            call agents are eligible for another promotion as
                            long as they have not received a strike and have
                            been recommended by 2 managers.
                          </p>
                          <p class="text-size-16 ">
                            <u>
                              <b>Expert Agent</b>
                            </u>{" "}
                            - These are the cream of the crop, the very best
                            call agents. Most call agents do not reach this
                            level during the first 6months. These call agent
                            assist in the training process and often time have
                            other call agents sit in and shadow their calls.
                            When we are looking for Team leads, this is where
                            our management team looks first.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <h2 className="text-center my-5">Billing Questions</h2>
      <div class="accordian-section">
        <div class="container">
          <div class="row">
            <div class="col-lg-6 col-md-6 col-sm-12">
              <div class="about-service-section-text accordian-section-inner-text position-relative">
                <div class="accordian-inner">
                  <div id="accordion9">
                    <div class="accordion-card">
                      <div class="card-header" id="heading23">
                        <h4 class="mb-0">
                          <button
                            class="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse23"
                            aria-expanded="false"
                            aria-controls="collapse23"
                          >
                            What kind of reports do we receive?
                          </button>
                        </h4>
                      </div>
                      <div
                        id="collapse23"
                        class="collapse"
                        aria-labelledby="heading23"
                      >
                        <div class="card-body">
                          <p class="text-size-16 ">
                            RRS provides its clients with an online portal which
                            allow you to review all statistics based on:
                          </p>
                          <p class="text-size-16 ">
                            · Individual stores or Groups of stores
                          </p>
                          <p class="text-size-16 ">
                            · Days, weeks, months or years
                          </p>
                          <p class="text-size-16 ">
                            1. Time stamp of all calls by date and time
                          </p>
                          <p class="text-size-16 ">
                            2. Break down on total calls by store
                          </p>
                          <p class="text-size-16 ">3. Average Wait Time</p>
                          <p class="text-size-16 ">4. Average Handle Time</p>
                          <p class="text-size-16 ">5. Total Handle Time</p>
                          <p class="text-size-16 ">
                            6. Break down of calls by Delivery and Carryout
                          </p>
                          <p class="text-size-16 ">7. Total Amount of Orders</p>
                          <p class="text-size-16 ">8. Total Upsells</p>
                          <p class="text-size-16 ">
                            We are also able to customize reports as required.
                          </p>
                        </div>
                      </div>
                    </div>
                    <div class="accordion-card">
                      <div class="card-header" id="heading24">
                        <h4 class="mb-0">
                          <button
                            class="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse24"
                            aria-expanded="false"
                            aria-controls="collapse24"
                          >
                            How are payments made?
                          </button>
                        </h4>
                      </div>
                      <div
                        id="collapse24"
                        class="collapse"
                        aria-labelledby="heading24"
                      >
                        <div class="card-body">
                          <p class="text-size-16 ">
                            RRS uses Bill.com to Auto draft your account every
                            Friday.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-6 col-md-6 col-sm-12">
              <div class="about-service-section-text position-relative">
                <div class="accordian-inner">
                  <div id="accordion10">
                    <div class="accordion-card">
                      <div class="card-header" id="heading25">
                        <h4 class="mb-0">
                          <button
                            class="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse25"
                            aria-expanded="false"
                            aria-controls="collapse25"
                          >
                            Why should we use RRS?
                          </button>
                        </h4>
                      </div>
                      <div
                        id="collapse25"
                        class="collapse"
                        aria-labelledby="heading25"
                      >
                        <div class="card-body">
                          <p class="text-size-16 ">
                            <u>
                              <b>Synergy</b>
                            </u>{" "}
                            - when the sum of the parts equals more than the
                            whole.
                          </p>
                          <p class="text-size-16 ">
                            You are the expert in making great food fast. We are
                            the experts in customer service and support.
                          </p>
                          <p class="text-size-16 ">
                            By allowing RRS to handle all your calls; you can
                            rest assure that a dedicated team of well trained
                            and managed professional call agents will treat your
                            customers to world class service.
                          </p>
                          <p class="text-size-16 ">
                            By taking the calls out of your stores, your
                            employees will be empowered to accomplish much more
                            and faster.
                          </p>
                          <p class="text-size-16 ">
                            RRS is currently taking over 5 million orders per
                            year, with over 500 call agents and working with
                            over 400 stores nationwide.
                          </p>
                          <p class="text-size-16 ">
                            In addition, RRS had developed its own call center
                            POS interface. Which is integrated with over 35 well
                            know POS systems in the restaurant industry. By
                            having our own POS system RRS is able to have
                            hundreds of call agents enter hundreds of orders at
                            the same time and operate quickly. Once the order is
                            submitted it is transferred directly to your stores
                            POS system.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default Faqs;
